import { render, staticRenderFns } from "./FormBuilderComponent.vue?vue&type=template&id=2c934d91&scoped=true"
import script from "./FormBuilderComponent.vue?vue&type=script&lang=js"
export * from "./FormBuilderComponent.vue?vue&type=script&lang=js"
import style0 from "./FormBuilderComponent.vue?vue&type=style&index=0&id=2c934d91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c934d91",
  null
  
)

export default component.exports